<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="flexBox">
      <text-title mainTitle="查看当前集中器" subheading="" />
      <div class="header-btn-box">
        <a @click="ToModifyDevice">修改</a>
        <a @click="strategyCenter">返回</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="line-text">设备名称：</div>
        <div>{{ deviceName || '无' }}</div>
      </div>
      <div class="form-line">
        <div class="line-text">设备编号：</div>
        <div>{{ deviceCode || '无' }}</div>
      </div>
      <div class="form-line">
        <div class="line-text">设备厂家：</div>
        <div>{{ deviceManufacturerName || '无' }}</div>
      </div>
      <div class="form-line">
        <div class="line-text">设备型号：</div>
        <div>{{ deviceModelName || '无' }}</div>
      </div>
      <div class="form-line">
        <div class="line-text">所属楼栋：</div>
        <div>{{ buildingName || '无' }}</div>
      </div>
      <div class="form-line">
        <div class="line-text">责任人：</div>
        <div>{{ responsiblePerson || '无' }}</div>
      </div>
    </form>
  </div>
</template>

<script>
import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
import { errorHandler } from '../../../utils/errorHandler'
import InputTree from '../../../components/common/inputs/input-tree'
import { api } from '../../api/SteamManagement'
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import { nSuccess } from '../../../utils/notice'

export default {
  components: {
    TextTitle,
    Breadcrumb,
    InputTree,
    BreadCrumb,
  },
  name: 'controller-current',
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: '智慧蒸汽',
            name: 'steam-over-view',
          },
          {
            value: '集中器管理',
          },
        ],
      },
      deviceName: '',
      deviceCode: '',
      deviceManufacturerName: '',
      deviceModelName: '',
      buildingName: '',
      responsiblePerson: '',
    }
  },
  created() {
    this.deviceCode = this.$route.params.id
    this.getsteamByCode()
  },
  methods: {
    getsteamByCode() {
      this.$axios
        .get(`${api.getSteamControlDeviceByCode}/${this.deviceCode}`, {})
        .then((res) => {
          let data = res.data.data
          this.deviceName = data.name
          this.deviceManufacturerName = data.deviceManufacturerName
          this.deviceModelName = data.deviceModelName
          this.buildingName = data.buildingName
          if (data.responsiblePersonName && data.responsiblePersonPhone) {
            this.responsiblePerson = `${data.responsiblePersonName} / ${data.responsiblePersonPhone}`
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    strategyCenter() {
      this.$router.push({
        name: 'steam-controller-management',
      })
    },
    ToModifyDevice() {
      this.$router.push({
        path: '/steam_controller_modify/' + this.$route.params.id,
      })
    },
  },
}
</script>

<style scoped>
.flexBox {
  display: flex;
  justify-content: space-between;
}
.header-btn-box {
  margin: 20px 0 10px 0;
  color: #337ab7;
  font-size: 14px;
}
.header-btn-box a {
  margin-right: 40px;
  cursor: pointer;
}
.header-btn-box a:hover {
  color: #00a0e6;
}
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.form-line {
  margin: 30px 0;
  display: flex;
  justify-content: flex-start;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
  width: 120px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/SteamManage/ControllerManagement/ControllerCurrent.vue